import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=26bba23a"
import script from "./Presupuestos.vue?vue&type=script&lang=js"
export * from "./Presupuestos.vue?vue&type=script&lang=js"
import style0 from "./Presupuestos.vue?vue&type=style&index=0&id=26bba23a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports